module.exports = __webpack_public_path__ + "img/heart.b851aa2e.png";